/**
 * How fast "Start" sends (Sofia, Oct 29 2026). LinkedIn publishes no rate for InMails and forbids
 * extensions that automate activity, so the run keeps a person's pace:
 *  - at most 25 per Start — LinkedIn's own "message several candidates" takes 25 at once;
 *  - 45–120 seconds, at random, between two InMails that went out (our estimate; LinkedIn gives none).
 * Sources: LinkedIn Help a417251 (25 recipients, credits per seat), 90586 (automated activity).
 */
export const SEND_BATCH = 25;
export const PAUSE_SECONDS = { min: 45, max: 120 } as const;

/** One pause, in ms, anywhere between the two bounds. */
export const pauseMs = (rand: () => number = Math.random) =>
  Math.round((PAUSE_SECONDS.min + rand() * (PAUSE_SECONDS.max - PAUSE_SECONDS.min)) * 1000);

/** 72_000 → "1:12". */
export function clock(ms: number) {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}
